import { Stack, Typography } from '@mui/material';
import React from 'react';
import CusInput from './CusInput';
import CusCheckbox from './CusCheckbox';
import TypographyText from './table/TypographyText';
import { useTranslation } from 'react-i18next';

const days = [
  { label: 'Mon', id: 1, value: '0' },
  { label: 'Tue', id: 2, value: '1' },
  { label: 'Wed', id: 3, value: '2' },
  { label: 'Thu', id: 4, value: '3' },
  { label: 'Fri', id: 5, value: '4' },
  { label: 'Sat', id: 6, value: '5' },
  { label: 'Sun', id: 7, value: '6' }
];

export default function DaysInputs({ selectDays, setSelectDays, label, disabled }) {
  const { t } = useTranslation();
  return (
    <Stack
      gap={1}
      direction={'row'}
      alignItems={'center'}
      sx={{ maxWidth: '100svw', overflow: 'auto' }}>
      <TypographyText color="textSecondary">{t(label)}</TypographyText>
      <Stack direction={'row'}>
        {days.map((day, indx) => (
          <CusCheckbox
            key={day.id}
            label={day.label}
            checked={selectDays[indx]}
            disabled={disabled}
            name={'days'}
            onChange={() =>
              setSelectDays((prev) => {
                const newPrev = [...prev];
                newPrev[indx] = !prev[indx];
                return newPrev;
              })
            }
          />
        ))}
      </Stack>{' '}
    </Stack>
  );
}
